
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <h1 className="flex items-center space-x-3">
            <img
              src="https://static.readdy.ai/image/5fb4188dc1db6e50d6c3e79cbe3ab0af/634b5c78b437941165c49867ed9d7e99.jpeg"
              alt="Mr. Auto Broker - AI-Powered Car Buying Service in Woodbridge, Ontario"
              className="h-12 w-12 rounded-full object-cover"
            />
            <div>
              <div className={`text-xl font-bold ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                Mr. Auto Broker
              </div>
              <div className={`text-xs ${scrolled ? 'text-gray-600' : 'text-white/80'}`}>
                AI-Powered Car Buying
              </div>
            </div>
          </h1>

          <div className="hidden md:flex items-center space-x-8">
            {['home', 'about', 'how-it-works', 'services', 'testimonials', 'contact'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? 'text-gray-700 hover:text-purple-600'
                    : 'text-white hover:text-purple-300'
                }`}
              >
                {item.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
              </button>
            ))}
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="bg-gradient-to-r from-cyan-500 to-purple-600 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
          >
            Start AI Consultation
          </button>
        </div>
      </div>
    </nav>
  );
}
